import styled from 'styled-components';
import { TriggerCanvas } from './TriggerCanvas';
import { Sidebar } from './components/Sidebar/Sidebar';
import { DragAndDropProvider } from 'components/experimental/DragAndDrop/Context/DragAndDropContext';
import { DrawerController } from './components/DrawerController';

const GridContainer = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: auto;
  grid-template-areas: 'drawer . canvas';
  grid-template-columns: 400px 10px 1fr;
`;

const GridDrawer = styled.div`
  grid-area: drawer;
  position: relative;
  background-color: ${({ theme }) => theme.vars.newColor.lightGS2};
`;

const GridCanvas = styled.div`
  grid-area: canvas;
  position: relative;
`;

export function CampaignWorkflowTab() {
  return (
    <>
      <DragAndDropProvider>
        <GridContainer>
          <GridDrawer>
            <Sidebar />
            <DrawerController />
          </GridDrawer>
          <GridCanvas>
            <TriggerCanvas />
          </GridCanvas>
        </GridContainer>
      </DragAndDropProvider>
    </>
  );
}
